module.exports = __webpack_public_path__ + "img/isFav.4d4c527a.svg";